import PropTypes from 'prop-types'
import React from 'react'
import cn from 'classnames'

import customPropTypes from 'util/customPropTypes'

import SidebarToplevelAccordion from './SidebarToplevelAccordion'
import SidebarAccordion from './SidebarAccordion'
import SidebarHeader from './SidebarHeader'
import SidebarFooter from './SidebarFooter'
import SidebarItem from './SidebarItem'
import styles from './styles.less'
import RefreshButton from './RefreshButton'

Sidebar.propTypes = {
  children: customPropTypes.children,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  footer: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

Sidebar.defaultProps = {
  action: [],
  children: [],
  footer: undefined,
}

Sidebar.ToplevelAccordion = SidebarToplevelAccordion
Sidebar.Accordion = SidebarAccordion
Sidebar.Header = SidebarHeader
Sidebar.Footer = SidebarFooter
Sidebar.Item = SidebarItem

export default function Sidebar({
  flexible,
  title,
  children,
  showRefreshButton,
  className,
  footer,
}) {
  return (
    <div
      className={cn(styles.Sidebar, className, {
        [styles['Sidebar-flexible']]: flexible,
      })}
    >
      <div className={styles.Header_container}>
        <h1 className={styles.Sidebar_TitleText}>
          {title}
          {showRefreshButton && <RefreshButton />}
        </h1>
      </div>
      <div className={styles.content}>{children}</div>
      {footer && <SidebarFooter>{footer}</SidebarFooter>}
    </div>
  )
}
